import CURRENCY_USD from '../constants/system/currencies';

export default class CurrencyService {
  private static CURRENCY_SIGN_USD: string = '$';
  private static INTL_NUMBER_FORMAT_STYLE_CURRENCY: IntlNumberFormatStyle = 'currency';
  private static INTL_NUMBER_FORMAT_CURRENCY_USD: string = 'USD';
  private static INTL_LOCALE_EN_US: string = 'en-US';
  private static MINIMUM_FRACTION_DIGITS_DEFAULT: number = 0;

  private static currencySignMap: Record<string, string> = {
    [CURRENCY_USD]: this.CURRENCY_SIGN_USD,
  };

  private static intlCurrencyMap: Record<string, string> = {
    [CURRENCY_USD]: this.INTL_NUMBER_FORMAT_CURRENCY_USD,
  };

  public static getCurrencyValue(value: number, currency: string): string | null {
    if (!currency) {
      return null;
    }

    const intlCurrency: string | null = this.intlCurrencyMap[currency];
    if (!intlCurrency) {
      return null;
    }

    return (new Intl.NumberFormat(this.INTL_LOCALE_EN_US, {
      style: this.INTL_NUMBER_FORMAT_STYLE_CURRENCY,
      currency: intlCurrency,
      minimumFractionDigits: this.MINIMUM_FRACTION_DIGITS_DEFAULT,
    })).format(value);
  }

  public static getCurrencySign(currency: string): string | null {
    if (!currency) {
      return null;
    }

    return this.currencySignMap[currency] || null;
  }
}
